<template>
  <div>
    <div class="page-header">
      <div class="cover">
        <h1 class="has-text-white is-family-secondary">
          Lunchtime Group<br />
          Resources
        </h1>
      </div>
    </div>
    <div class="container section tw-mt-5">
      <div class="columns">
        <div class="column">
          <div class="section-block">
            <span class="title">LUNCHTIME GROUP RESOURCES</span>
          </div>
          <div class="is-narrow" style="margin-top: -15px;">
            <b-field grouped position="is-right">
              <b-radio-button
                v-model="bookmarked"
                native-value="1"
                type="is-danger"
                class="bookmark-button"
                ><b-icon icon="bookmark" type="is-danger"></b-icon
              ></b-radio-button>
              <b-radio-button
                v-model="bookmarked"
                native-value="0"
                type="is-light"
                class="bookmark-button"
                ><b-icon icon="bookmark" type="is-light"></b-icon
              ></b-radio-button>
              <div class="tw-mt-1" style="width: 32px;">
                <a @click.stop.prevent="resetFilter()" v-if="isBookmarked">
                  <b-icon icon="close" type="is-light"></b-icon>
                </a>
              </div>
            </b-field>
          </div>

          <div v-for="category in resourceCategories.data" :key="category.id">
            <div v-if="category.resources.data.length > 0" class="tw-mb-20">
              <div class="tw-my-5 tw-justify-between clear-both">
                <div
                  class="content quill font-weight-thin"
                  v-html="category.display_name"
                />
              </div>

              <skeleton-loading class="column is-6 tw-p-0" v-if="loading" />
              <div class="columns is-multiline" v-else>
                <div
                  v-for="resource in filterResources(category.resources.data)"
                  :key="resource.id"
                  class="column is-3"
                >
                  <resource-card
                    redirect="resources.view"
                    :resource="newResource(resource)"
                    :loading.sync="loading"
                  />
                </div>
              </div>
              <b-pagination
                class="tw-mt-8"
                @click.stop=""
                v-if="category.resources.meta.last_page > 1"
                @change="setCategoryResources(category.id, $event)"
                :total="category.resources.meta.total"
                :current.sync="category.resources.meta.current_page"
                :per-page="category.resources.meta.per_page"
                order="is-centered"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
              >
              </b-pagination>
            </div>
          </div>
          <!-- Previous pagination here -->
        </div>
        <div class="column is-one-third">
          <div class="section-block">
            <span class="title">SUGGEST A RESOURCE</span>
          </div>
          <suggestion-form />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceCard from '@/components/ResourceCard'
import Resource from '@/models/Resource'
import ResourceCategory from '@/models/ResourceCategory'
import SuggestionForm from '@/components/SuggestionForm'
import * as ResourceType from '@/utils/consts/ResourceType'
import forEach from 'lodash/forEach'

export default {
  components: {
    ResourceCard,
    SuggestionForm
  },
  metaInfo: {
    title: 'Lunchtime Group Resources'
  },
  data() {
    return {
      submitting: false,
      oneWeekPromise: null,
      fourWeekPromise: null,
      bookmarked: null,
      isBookmarked: null,
      loading: false,
      resourceCategories: {
        data: [],
        meta: {
          current_page: 1
        }
      },
      resourcePage: {
        id: null
      }
    }
  },
  async mounted() {
    await this.getCategories()
  },
  watch: {
    bookmarked(n) {
      if (n !== null) {
        this.isBookmarked = this.bookmarked
      } else {
        this.isBookmarked = null
      }
      this.getCategories()
    }
  },
  methods: {
    newResource(resource) {
      return new Resource(resource)
    },
    async getResourcePromise(catId, page = 1) {
      this.loading = true
      return Resource.include('cover')
        .where('type', ResourceType.LTG)
        .where('resource_category_id', catId)
        .where('is_bookmarked', this.isBookmarked)
        .page(parseInt(page))
        .limit(8)
        .get()
    },
    async getCategories(page = 1) {
      this.loading = true
      return ResourceCategory.where('type', ResourceType.LTG)
        .where('is_bookmarked', this.isBookmarked)
        .page(1)
        .limit(9999)
        .get()
        .then(async response => {
          this.resourceCategories = response
          await this.setCategoryResources(null, page)
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    async setCategoryResources(catId, page) {
      await forEach(this.resourceCategories, async categories => {
        if (Array.isArray(categories)) {
          await forEach(categories, async category => {
            if (category.resources.data.length > 0) {
              this.$set(category.resources, 'data', [])

              if (catId === category.id) {
                this.resourcePage.id = catId
                this.$set(
                  category,
                  'resources',
                  await this.getResourcePromise(catId, page)
                )
              } else {
                this.$set(
                  category,
                  'resources',
                  await this.getResourcePromise(category.id)
                )
              }
            }
          })
        }
      })
      this.loading = false
    },
    resetFilter() {
      this.bookmarked = null
      this.getCategories()
    },
    filterResources(resources) {
      return resources.filter(
        resource =>
          this.isBookmarked === null ||
          (parseInt(this.isBookmarked) === 1 && resource.is_bookmarked) ||
          (parseInt(this.isBookmarked) === 0 && resource.is_bookmarked === null)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  background: center / cover no-repeat url(/img/resources-header.jpg) !important;
}

.quill {
  font-size: 1.5rem !important;
  p {
    strong {
      font-weight: bolder !important;
    }
  }
}
</style>
